import { compose } from 'redux';
import { connect } from 'react-redux';
import PanelAppearance from '../../components/handoff/PanelAppearance';
import { getSelectedElement } from '../../selectors/handoff';
import * as handoff from '../../utils/handoff/element';
import onlyIf from '../../hocs/onlyIf';
function mapStateToProps(state) {
    var element = getSelectedElement(state);
    return {
        shapeStyle: handoff.getShapeStyle(element),
        symbol: handoff.getSymbol(element),
    };
}
export default compose(connect(mapStateToProps), onlyIf(function (_a) {
    var shapeStyle = _a.shapeStyle, symbol = _a.symbol;
    return shapeStyle || symbol;
}))(PanelAppearance);
